var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ThemeContext, ThemeFactory, Tooltip, } from "@skbkontur/react-ui";
import { addListener } from "@skbkontur/react-ui/lib/LayoutEvents";
import { containsTargetOrRenderContainer } from "@skbkontur/react-ui/lib/listenFocusOutside";
import styles from "./MiniTooltip.module.css";
var MiniTooltipTheme = ThemeFactory.create({
    tooltipBg: "#0697FF",
    tooltipBorderRadius: "8px",
    tooltipTextColor: "white",
    tooltipCloseBtnColor: "rgba(255, 255, 255, 0.374)",
    tooltipCloseBtnHoverColor: "white",
});
var MiniTooltip = /** @class */ (function (_super) {
    __extends(MiniTooltip, _super);
    function MiniTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasElem: true };
        _this.checkTargetAvailability = function () {
            if (!_this.props.anchorElement()) {
                if (_this.state.hasElem) {
                    _this.props.onSkip && _this.props.onSkip();
                    _this.setState({ hasElem: false });
                }
            }
            else {
                if (!_this.state.hasElem) {
                    _this.props.onContinue && _this.props.onContinue();
                    _this.setState({ hasElem: true });
                }
            }
        };
        return _this;
    }
    MiniTooltip.prototype.componentWillMount = function () {
        if (!this.props.anchorElement()) {
            this.setState({ hasElem: false });
        }
    };
    MiniTooltip.prototype.componentDidMount = function () {
        if (!this.state.hasElem) {
            this.props.onSkip && this.props.onSkip();
        }
        else {
            this.layoutEventsToken = addListener(this.checkTargetAvailability);
        }
    };
    MiniTooltip.prototype.componentWillUnmount = function () {
        this.layoutEventsToken && this.layoutEventsToken.remove();
    };
    MiniTooltip.prototype.render = function () {
        var _this = this;
        var anchor = this.props.anchorElement();
        if (!anchor && !this.state.hasElem)
            return React.createElement("span", null);
        var elementsToClick = anchor ? [anchor] : [];
        if (this.props.triggers) {
            elementsToClick = elementsToClick.concat(this.props.triggers.map(function (g) { return g(); }));
        }
        var isClickOnTarget = function (event) {
            if (!(event.target instanceof Element))
                return false;
            var elementClicked = containsTargetOrRenderContainer(event.target);
            return elementsToClick.some(function (e) { return elementClicked(e); });
        };
        var onCloseRequest = function (event) {
            event &&
                isClickOnTarget(event) &&
                _this.props.onTargetClicked &&
                _this.props.onTargetClicked();
        };
        var onCloseClick = function () {
            _this.props.onClose && _this.props.onClose();
        };
        return (React.createElement(ThemeContext.Provider, { value: MiniTooltipTheme },
            React.createElement(Tooltip, { anchorElement: anchor || undefined, allowedPositions: this.props.allowedPositions, pos: this.props.allowedPositions[0], trigger: "opened", onCloseClick: onCloseClick, onCloseRequest: onCloseRequest, render: function () {
                    return (React.createElement("div", { className: styles.body, style: { width: _this.props.width } }, _this.props.render()));
                } })));
    };
    MiniTooltip.defaultProps = {
        positions: ["bottom center"],
        onClose: function () { },
        offset: 12,
    };
    return MiniTooltip;
}(React.Component));
export { MiniTooltip };
